module.exports = __webpack_public_path__ + "img/4.2ef2ea50.jpg";